const initialState = {
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  searchOptions: {},
  searchResults: [],
  allData: [],
  currentApiData: "",
  searchResults: {},
  selectedExtractionModel: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  tableLoading: false,
  sidebarLoading: false,
  modalLoading: false,
  showApiModel: false,
};

const ExtractionModelReducer = (state = initialState, action) => {
  const { type, payload, data, id } = action;

  switch (type) {
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: action.data,
      };
    case "SET_SEARCH_RESULTS_MODEL":
      return {
        ...state,
        searchResults: data.content,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        currentPage: data.page,
      };
    case "SET_EXTRACTION_MODEL":
      return {
        ...state,
        // allData: Array.isArray(data.data.content) ? data.data.content : [],
        allData: Array.isArray(data) ? data : [],
      };

    case "ADD_EXTRACTION_MODEL":
      return {
        ...state,
        currentApiData: payload,
        // allData: [...state.allData, payload],
        // total: state.total + 1,
      };

    case "SET_EXTRACTION_MODEL_BY_ID":
      return {
        ...state,
        selectedExtractionModel: data,
      };

    case "DELETE_EXTRACTION_MODEL":
      return {
        ...state,
        allData: state.allData.filter((item) => item.id !== id),
        searchResults: state.searchResults.filter((item) => item.id !== id),
        total: state.total - 1,
      };
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: action.value,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };

    case "OPEN_MODEL_API":
      return {
        ...state,
        showApiModel: action.value,
      };

    case "SET_MODAL_LOADING":
      return {
        ...state,
        modalLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    case "FILTER_API_DATA":
      let value = action.value;
      let filteredData = [];
      if (value.length) {
        filteredData = state.allData.filter((item) => {
          let startsWithCondition =
            item.name.toLowerCase().startsWith(value.toLowerCase()) ||
            item.organisationName.toLowerCase().startsWith(value.toLowerCase());

          let includesCondition =
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.organisationName.toLowerCase().includes(value.toLowerCase());

          if (startsWithCondition) {
            return startsWithCondition;
          } else if (!startsWithCondition && includesCondition) {
            return includesCondition;
          } else return null;
        });

        return {
          ...state,
          filteredData,
        };
      } else {
        filteredData = state.data;
        return { ...state, filteredData };
      }

    default:
      return state;
  }
};

export default ExtractionModelReducer;
